import * as React from 'react'
import {useTranslation, useEnvironment} from '@wix/yoshi-flow-editor'
import {Button} from 'wix-ui-tpa/Button'
import {TextButton} from 'wix-ui-tpa/TextButton'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Tooltip} from 'wix-ui-tpa/Tooltip'
import {InnerSummary} from '../inner-summary'
import {classes} from './summary.st.css'
import {SummaryProps} from '.'

export const Summary = ({
  invoice,
  selectedTickets,
  withoutBreakdown,
  inTickets,
  onCheckoutClick,
  onBackClick,
  eventPreview,
}: SummaryProps) => {
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()

  return (
    <div className={classes.container}>
      {selectedTickets || inTickets ? (
        <InnerSummary invoice={invoice} withoutBreakdown={withoutBreakdown} selectedTickets={selectedTickets} />
      ) : (
        t('seatings_selectTickets')
      )}
      <CheckoutButton
        onCheckoutClick={onCheckoutClick}
        previewCheckout={eventPreview}
        isMobile={isMobile}
        inTickets={inTickets}
        selectedTickets={selectedTickets}
        t={t}
      />
      {isMobile && inTickets ? (
        <TextButton className={classes.textButton} onClick={onBackClick}>
          {t('seatings_backToSelectingTickets')}
        </TextButton>
      ) : null}
    </div>
  )
}

const CheckoutButton = ({previewCheckout, onCheckoutClick, inTickets, selectedTickets, isMobile, t}) => {
  if (!onCheckoutClick) {
    return null
  }

  const getCheckoutText = () => {
    if (!isMobile) {
      return t('seatings_desktopCheckout')
    }

    return inTickets ? t('seatings_continueToCheckout') : t('seatings_checkout', {count: selectedTickets})
  }

  const button = (
    <Button
      data-hook={inTickets ? DH.CHECKOUT : DH.REVIEW_AND_CHECKOUT}
      fullWidth
      upgrade
      className={classes.button}
      disabled={!selectedTickets || previewCheckout}
      onClick={onCheckoutClick}
    >
      {getCheckoutText()}
    </Button>
  )

  if (previewCheckout) {
    return (
      <Tooltip content={t('seatingCheckoutPreviewTooltip')} fluid={true}>
        {button}
      </Tooltip>
    )
  }

  return button
}
